import { render, staticRenderFns } from "./BrandNameMaker.vue?vue&type=template&id=e21e1f92&"
import script from "./BrandNameMaker.vue?vue&type=script&lang=js&"
export * from "./BrandNameMaker.vue?vue&type=script&lang=js&"
import style0 from "./BrandNameMaker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports